// removed by extract-text-webpack-plugin
module.exports = {"section":"section__27zkP","card-title":"card-title__3syPS","table-row":"table-row__2btHB","table-title":"table-title__3LiWt","table-container":"table-container__MttMM"};


//////////////////
// WEBPACK FOOTER
// ./styles/dashboard/redeemOrderPlaced.scss
// module id = 1251
// module chunks = 68